import { createStore, createEvent, createEffect } from 'effector';

// События
export const setGlobalSessionExpired = createEvent<boolean>();
export const resetSession = createEvent();

// Эффект для обработки ошибок сессии
export const handleSessionError = createEffect<{ error: any; context: string }, void>(({ error, context }) => {
  console.log(`Session error in ${context}:`, error);
  
  const isSessionExpired = error.message?.toLowerCase().includes('сеанс истек') ||
                          error.message?.toLowerCase().includes('session expired') ||
                          error.message?.toLowerCase().includes('401') ||
                          error.status === 401;
  
  if (isSessionExpired) {
    console.log(`Session expired detected in ${context}, setting global session expired state`);
    setGlobalSessionExpired(true);
  }
});

// Тип состояния
export interface SessionState {
  isSessionExpired: boolean;
  lastErrorContext: string | null;
}

// Store
export const sessionStore = createStore<SessionState>({
  isSessionExpired: false,
  lastErrorContext: null,
})
  .on(setGlobalSessionExpired, (state, isSessionExpired) => ({
    ...state,
    isSessionExpired,
    lastErrorContext: isSessionExpired ? state.lastErrorContext : null
  }))
  .on(handleSessionError.done, (state, { params }) => ({
    ...state,
    lastErrorContext: params.context
  }))
  .on(resetSession, (state) => ({
    ...state,
    isSessionExpired: false,
    lastErrorContext: null
  }));

// Утилита для проверки и обработки ошибок сессии
export const checkSessionError = (error: any, context: string): boolean => {
  const isSessionExpired = error.message?.toLowerCase().includes('сеанс истек') ||
                          error.message?.toLowerCase().includes('session expired') ||
                          error.message?.toLowerCase().includes('401') ||
                          error.status === 401;
  
  if (isSessionExpired) {
    handleSessionError({ error, context });
    return true;
  }
  
  return false;
};

// Утилита для создания ошибки с информацией о сессии
export const createSessionError = (error: any, context: string) => {
  const isSessionExpired = checkSessionError(error, context);
  
  return {
    message: error.message || 'Произошла ошибка',
    isSessionExpired,
    context
  };
};
